(() => {
    const windowParentUrl = window.parent?.location?.href || "";
    if (windowParentUrl.includes("SiteEditor")) {
        return;
    }

    const header = document.querySelector("header.header-template .header-container");
    const spacer = document.querySelector(".header-spacer");
    if (!header || !spacer) return;

    const buttonContainer = header.querySelector(".button-container");
    const siteContainer = document.querySelector(".site-container");

    let placeholder = null;
    const mq = window.matchMedia("(max-width: 47.99rem)");
    let headerTop = 0;

    const moveButtons = () => {
        if (!buttonContainer || !siteContainer || buttonContainer?.classList.contains("model-page")) return;

        if (!placeholder) {
            placeholder = document.createComment("button-container-placeholder");
            buttonContainer.before(placeholder);
        }

        if (mq.matches) {
            siteContainer.append(buttonContainer);
        } else {
            placeholder.after(buttonContainer);
        }

        measure();
        update();
    };

    let headerH = Math.round(header.getBoundingClientRect().height);
    let lastSticky = null;
    let ticking = false;

    const measure = () => {
        headerTop = Math.round(header.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0));
        headerH = Math.round(header.getBoundingClientRect().height);
        if (header.classList.contains("sticky")) spacer.style.setProperty("--dynamic-height", headerH);
    };

    const spacerToZeroNoAnim = () => {
        spacer.classList.add("no-trans");
        spacer.style.setProperty("--dynamic-height", "0");
        spacer.offsetHeight;
        spacer.classList.remove("no-trans");
    };

    const update = () => {
        ticking = false;

        const st = window.pageYOffset || document.documentElement.scrollTop || 0;
        const isSticky = st >= headerTop;

        if (isSticky === lastSticky) return;
        lastSticky = isSticky;

        if (isSticky) {
            spacer.style.setProperty("--dynamic-height", headerH);
            header.classList.add("sticky");
            siteContainer.classList.add("header-sticky");
            requestAnimationFrame(() => header.classList.add("sticky--show"));
        } else {
            header.classList.remove("sticky", "sticky--show");
            siteContainer.classList.remove("header-sticky");
            spacerToZeroNoAnim();
        }
    };

    const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", () => {
        moveButtons();
        measure();
    });

    if (mq.addEventListener) mq.addEventListener("change", moveButtons);
    else mq.addListener(moveButtons);

    moveButtons();
    update();
})();
